import React, { useContext } from 'react';
import { oneOfType, object, string, array } from 'prop-types';
import { Drawer, Grid, styled } from '@nextiva/next-ui-components';

import { CallForwardContext, actionTypes } from 'containers/CallForwarding';
import { Snackbar } from 'components/Snackbar';
import Header from './Header';

const DrawerBody = styled('div')`
  width: 40vw;
  min-width: 575px;
  padding: 20px 24px;
`;

const InfoBanner = styled('div')`
  padding: 16px 20px;
  margin: 0 0 16px 0;
  border-radius: 4px;
  background: #edf4f7;
  color: #222648;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  letter-spacing: 0.21px;
`;

const DrawerWrapper = ({ children, fields = [], title }) => {
  const { state, dispatch } = useContext(CallForwardContext);

  const closeDrawer = () => {
    dispatch({
      type: actionTypes.TOGGLE_DRAWER,
      payload: {
        open: false,
        type: '',
        updateIndex: null,
      },
    });
  };

  return (
    <Drawer open={state.drawer.open} anchor="right">
      <Header title={title} closeDrawer={closeDrawer} />
      <DrawerBody>
        <Snackbar isDrawer />
        {!fields.length && (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InfoBanner data-testid="PlatformAdminUI-TeamVoiceSettings-Drawer-BannerInfo">
                Add conditions to enable Selective call forwarding. You can
                forward calls based on a schedule (i.e. during lunch or after
                hours) or depending on who you are receiving a call from.
              </InfoBanner>
            </Grid>
          </Grid>
        )}
        {children}
      </DrawerBody>
    </Drawer>
  );
};

DrawerWrapper.propTypes = {
  children: oneOfType([object, string]),
  fields: array,
  title: string,
};

export default DrawerWrapper;
